module.exports = __webpack_public_path__ + "d3d79b62a305ee608a77bd00612670fe.pdf";